var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEraser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  id: "eraser_svg__Icons",
  width: 28,
  height: 20,
  viewBox: "0 0 32 32"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:none;stroke:#000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M28 12.5c.8-.8.8-2 0-2.8L22.4 4c-.8-.8-2-.8-2.8 0L5 18.5c-.8.8-.8 2 0 2.8l3.8 3.8h6.6zM12.5 11.1l8.4 8.4M5 29h22",
  className: "st0"
})));
export default SvgEraser;